import {
  Order, OrderStatus, Department, StaffMember, InventoryItem,
  PaginationInfo, ApiResponse, Vendor,
} from '../../lib/types';

export type SortColumn =
  | 'order_date' | 'department_name' | 'vendor' | 'order_number' | 'status' | 'total_cost';
export type SortDir = 'asc' | 'desc';

export const ALL_STATUSES: OrderStatus[] = ['Pending', 'Ordered', 'Delivered', 'Closed'];

export const STATUS_ORDER: Record<string, number> = {
  pending: 0, ordered: 1, delivered: 2, closed: 3,
  Pending: 0, Ordered: 1, Delivered: 2, Closed: 3,
};

export interface FormItem {
  item_name: string; quantity: number; unit_price: number; size: string; sku: string;
}
export const emptyItem = (): FormItem => ({ item_name: '', quantity: 1, unit_price: 0, size: '', sku: '' });

export interface DashboardTabProps {
  filteredOrders: Order[];
  locale:         string;
  currency:       string;
  onStatusChange: (order: Order, newStatus: OrderStatus) => void;
  onDelete:       (id: string) => void;
  departments:    Department[];
  staffDirectory: StaffMember[];
  categories:     string[];
  vendors:        Vendor[];
  onOrderAdded:   () => void;
  showToast:      (msg: string, type?: 'success' | 'error') => void;
  addOrderTrigger?: number;
  importTrigger?:   number;
  onInventoryAdd:   (payload: {
    item_name: string; sku?: string; size?: string;
    quantity?: number; low_stock_threshold?: number; target_department_id?: string;
  }) => Promise<ApiResponse<InventoryItem>>;
  onInventoryChanged: () => void;
  inventory?:         InventoryItem[];
  serverPagination?:  PaginationInfo;
  onPageChange?:      (page: number) => void;
}

export interface ConfirmState {
  message: string;
  label: string;
  destructive?: boolean;
  onConfirm: () => void;
}
